import script from "./FactBox.vue?vue&type=script&setup=true&lang=js"
export * from "./FactBox.vue?vue&type=script&setup=true&lang=js"

import "./FactBox.vue?vue&type=style&index=0&id=3fcf08d4&scoped=true&lang=scss"

import exportComponent from "/Users/rantalmor/Desktop/volta-vue/proposal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3fcf08d4"]])

export default __exports__